// extracted by mini-css-extract-plugin
var _1 = "_99pozyCFbU4u53Msz9Mc";
export { _1 as "formGroup" }
export default { "formGroup": _1 }
